import { config } from '../../utils/config';
import { configureStore as devStore } from './configureStore.dev';
import { configureStore as prodStore } from './configureStore.prod';

export const configureStore = config.ENV === 'local' || config.ENV === 'dev' ? devStore : prodStore;
